import { Navigate, useParams } from 'react-router-dom'

import { DOCS_HOME } from './explorer-paths'

/**
 * Preserve bookmarks under `/docs` after the library moved to `/documents`.
 * `/docs`, `/docs/<path>`, and `/docs/f/<folder>` all land on the matching
 * `/documents` URL.
 */
export function LegacyDocsRedirect() {
  const { '*': rest } = useParams()
  const suffix = rest && rest.length > 0 ? `/${rest}` : ''
  return <Navigate to={`${DOCS_HOME}${suffix}`} replace />
}
